import { useNavLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import getPageSection from '#client/utils/getPageSection';

import * as Styled from './MenuItem.style';

const MenuItem = ({ section, onClick, index }) => {
  const { pathname } = useLocation();
  const linkPressedCallback = useNavLinkPressedCallback({
    elementText: section.title,
    elementName: 'user_menu_button',
    linkDestination: section.path,
    navIndex: index + 1,
    navLevel: 1,
    pageCategory: 'dashboard',
    pageSection: getPageSection(pathname)
  });
  const handleMenuItemClick = () => {
    onClick();
    linkPressedCallback();
  };

  return (
    section.type === 'divider'
      ? <Styled.Root className="is-divider" />
      : (
        <Styled.Root>
          <Styled.Link
            onClick={handleMenuItemClick}
            to={section.path}
          >
            <SharedAsset
              alt={section.icon.alt}
              src={`/s2/icon/${section.icon.src}`}
              width={16}
            />
            <Styled.TruncatedText>{section.title}</Styled.TruncatedText>
          </Styled.Link>
        </Styled.Root>
      )
  );
};

MenuItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  section: PropTypes.shape({
    type: PropTypes.string,
    title: PropTypes.string,
    path: PropTypes.string,
    icon: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    })
  }).isRequired
};

export default MenuItem;
